module.exports = __webpack_public_path__ + "img/柳铭心.d787ee4a.png";